import { render, staticRenderFns } from "./widget_open_positions.vue?vue&type=template&id=cfa9f5c6&scoped=true&"
import script from "./widget_open_positions.vue?vue&type=script&lang=js&"
export * from "./widget_open_positions.vue?vue&type=script&lang=js&"
import style0 from "./widget_open_positions.vue?vue&type=style&index=0&id=cfa9f5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa9f5c6",
  null
  
)

export default component.exports